'use client'

import React, { createContext, useContext, useState } from 'react'

type FunnelBuilderMode = 'library' | 'editor'

type FunnelBuilderModeContextValue = {
  builderMode: FunnelBuilderMode
  setBuilderMode: React.Dispatch<React.SetStateAction<FunnelBuilderMode>>
}

const FunnelBuilderModeContext =
  createContext<FunnelBuilderModeContextValue | null>(null)

export function FunnelBuilderModeProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [builderMode, setBuilderMode] =
    useState<FunnelBuilderMode>('library')

  return (
    <FunnelBuilderModeContext.Provider
      value={{
        builderMode,
        setBuilderMode,
      }}
    >
      {children}
    </FunnelBuilderModeContext.Provider>
  )
}

export function useFunnelBuilderMode() {
  const context = useContext(FunnelBuilderModeContext)

  if (!context) {
    throw new Error(
      'useFunnelBuilderMode must be used within a FunnelBuilderModeProvider'
    )
  }

  return context
}